<template>
  <div class="form-row d-info d-frame">
    <h3>CDA Premium <span v-if="time === 1">1 miesiąc</span><span v-if="time === 3">3 miesiące</span> – wszystkie filmy i telewizja na żywo</h3>
    <p>Wybierz CDA Premium, jeden z najdynamiczniej rozwijających się serwisów wideo na życzenie w Polsce. Korzystaj bez ograniczeń z bogatej biblioteki licencjonowanych filmów i seriali: znakomite horrory, trzymające w napięciu thrillery, kino akcji, filmy i bajki dla dzieci dostępne z dubbingiem,
      komedie romantyczne oraz wciągające seriale. Teraz dodatkowo także z kilkudziesięcioma kanałami telewizyjnymi w pakiecie - VOD i TV na żywo w jednym miejscu!</p>
    <p>Lista kanałów w pakiecie TV dostępna w tym miejscu: <a href="https://www.cda.pl/tv" target="_blank" rel="nofollow">www.cda.pl/tv</a> (zakładka „Pakiet Start”)</p>
    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <h3>Jak wykorzystasz kod?</h3>
      <ul style="list-style: none">
        <li>Krok 1 – Wejdź na stronę <a href="https://www.cda.pl/kod" target="_blank" rel="nofollow">www.cda.pl/kod</a></li>
        <li>Krok 2 – Zaloguj się i załóż nowe konto</li>
        <li>Krok 3 – Przepisz otrzymany kod</li>
        <li>Krok 4 – Twoje konto jest już aktywne</li>
      </ul>
      <h3>Zasady i warunki wykorzystania:</h3>
      <p>Z CDA Premium możesz korzystać na komputerze, na telefonie i tablecie
        (konieczne pobranie darmowej aplikacji), na telewizorach z systemem AndroidTV
        oraz wielu innych markach, a także korzystając z przystawki Chromecast. Regulamin
        usługi CDAPremium oraz korzystania z serwisu znajdziesz na stronie
        <a href="https://www.cda.pl/regulamin/premium" target="_blank" rel="nofollow">www.cda.pl/regulamin/premium</a>. Karta i kod nie podlegają zwrotowi,
        wymianie na gotówkę ani odsprzedaży. Minimalny wiek osoby kupującej 13 lat. Kod
        nie ma terminu ważności.</p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoCdaPremium',
  props: ['time'],
  data () {
    return {
      showMore: false
    }
  }
}
</script>
